import { FormikProps } from "formik";
import { FileWithPreview } from "./uploads";

export enum IAdBannerStatus {
    AD_ACTIVE = 1,
    AD_INACTIVE = 0
}

export enum IAdBannerType {
    AD_HORIZONTAL_BANNER = 0,
    AD_SMALL_BANNER = 1,
    AD_BACKGROUND_BANNER = 2
}

export interface IAdServerBannerRequestDto {
    adId?: string;
    adFileName: string;
    s3Key: string;
    adPosition: IAdBannerType;
    adImageAlttext: string;
    adImageUrl: string;
    adStatus: IAdBannerStatus;
}

export interface IAdFile {
    fileName: string;
    s3Key: string;
}

export interface IAdServerRollAdRequestDto {
    campaignId: string;
    campaignName: string;
    visibility: boolean;
    preRollAds: IAdFile[];
    midRollAds: IAdFile[];
    postRollAds: IAdFile[];
    targetPlaylists: string[];
    targetVideos: string[];
}

export interface IAdServerUpdateCampaignRequestDto {
    campaign?: any;
    campaignName?: string;
    visibility: boolean;
    targetPlaylists?: string[];
    targetVideos?: string[];
    //videoFiles: FileWithPreview[]; 
}
export interface Campaign {
    campaignId: string;
    title: string;
    videos: string;
    categories: string[];
    visibility: boolean;
    createdAt?: string;
}

export interface RollAdsListProps {
    campaigns: Campaign[];
    handleDeleteCampaign: (campaignId: string) => Promise<void>;
    fetchCampaigns: () => void
}
export interface IRollAdsModalCardProps {
    uploadedFile: any[];
    handleDeleteFile: (fileIndex: number) => void;
    adsType: string;
    setAdsType: React.Dispatch<React.SetStateAction<string>>;
    setUploadedFiles: React.Dispatch<React.SetStateAction<any>>;
    handleTypeChange: (index: number, newType: string) => void;
    setCount: React.Dispatch<React.SetStateAction<boolean>>;
    count: boolean;
    formik: FormikProps<{ title: string; videoFiles: FileWithPreview[]; displayOption: string[]; isVisible: boolean }>;
}

export interface IRollAdsModalBodyProps {
    campaignId: string | null;
    isEdit: boolean;
    onClose: () => void;
    fetchCampaigns: () => void
}

export interface IRollAdsModalFormProps {
    formik: FormikProps<{ title: string; videoFiles: FileWithPreview[]; displayOption: string[]; isVisible: boolean }>;
    onDropHandler: (acceptedFiles: FileWithPreview[]) => void;
    handleVisibilityToggle: () => void;
    displayOptions: { value: string; label: string }[];
    uploadedFile: any[];
    isEditing: boolean;
    isEdit: boolean;
    setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
    handleDeleteFile: (fileIndex: number) => void;
    adsType: string;
    setAdsType: React.Dispatch<React.SetStateAction<string>>;
    setUploadedFiles: React.Dispatch<React.SetStateAction<any>>;
    resetForm: () => void;
    onClose: () => void;
    percentage: number;
    isDisabled?: boolean;
    editData?: any

}

export interface IRollAdsModalProps {
    show: boolean;
    onClose: () => void;
    campaignId: string | null;
    isEdit?: boolean;
    fetchCampaigns: () => void
}


export enum AdType {
    PreRoll = "Pre-roll",
    MidRoll = "Mid-roll",
    PostRoll = "Post-roll",
  }